import { useProgramDiagnosticsSync } from '../hooks/editor/useProgramDiagnosticsSync';

const ProgramDiagnosticsSync = () => {
  useProgramDiagnosticsSync();
  return null;
};

export default ProgramDiagnosticsSync;
